// Icon + label for the stage reward shown next to the Lucky Spin progress bar.
// Reward type/value come from GET /v1/lucky-spin/progress → nextReward
// (configured in admin → Progress Rewards; TON_COINS is paid to the TON balance).
export const STAGE_REWARD_ICONS = {
  TICKETS:   '/ticket_icon.png',
  COINS:     '/coin_icon.png',
  TON_COINS: '/gram.png',
};

export function formatStageReward(reward) {
  const type  = reward?.type || 'TICKETS';
  const value = Number(reward?.value);
  const icon  = STAGE_REWARD_ICONS[type] || '/ticket_icon.png';
  if (!Number.isFinite(value)) return { icon, label: '', type };
  let label;
  if (type === 'TON_COINS') {
    // TON is fractional: 0.05 → "0.05", 1 → "1"
    const decimals = (String(value).split('.')[1] || '').length;
    label = Number.isInteger(value) ? String(value) : value.toFixed(Math.min(4, decimals));
  } else {
    label = Math.round(value).toLocaleString();
  }
  return { icon, label, type };
}
